export const CUSTOM_CLASSES = {
  boldClass: 'bold',
  noBoldClass: 'no-bold',
  noMarginClass: 'no-margin',
  alignRight: 'align-right',
  alignLeft: 'align-left',

  // align all but first column
  alignRightValuesOnly: 'align-right-values-only',
  alignLeftValuesOnly: 'align-left-values-only',
};

export const customClassesToRowStyleMap = {
  [CUSTOM_CLASSES.boldClass]: {
    font: { bold: true },
  },
  [CUSTOM_CLASSES.noBoldClass]: {
    font: { bold: false },
  },
  [CUSTOM_CLASSES.alignRight]: {
    alignment: { horizontal: 'right' },
  },
  [CUSTOM_CLASSES.alignLeft]: {
    alignment: { horizontal: 'left' },
  },
};

export const customClassToRowStyleMapValuesOnly = {
  [CUSTOM_CLASSES.alignRightValuesOnly]: {
    alignment: { horizontal: 'right' },
  },
  [CUSTOM_CLASSES.alignLeftValuesOnly]: {
    alignment: { horizontal: 'left' },
  },
};
